import { render, staticRenderFns } from "./MyMenuItem.vue?vue&type=template&id=da9c22ac&scoped=true"
import script from "./MyMenuItem.vue?vue&type=script&lang=js"
export * from "./MyMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MyMenuItem.vue?vue&type=style&index=0&id=da9c22ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9c22ac",
  null
  
)

export default component.exports